export default __webpack_public_path__ + "assets/07_ElevationProfile.png";